import { render, staticRenderFns } from "./TrainerDialog.vue?vue&type=template&id=b2b66f28&scoped=true&"
import script from "./TrainerDialog.vue?vue&type=script&lang=js&"
export * from "./TrainerDialog.vue?vue&type=script&lang=js&"
import style0 from "./TrainerDialog.vue?vue&type=style&index=0&id=b2b66f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b66f28",
  null
  
)

export default component.exports